export enum EstadosComprobanteElectronicoEmpresa {
    ACTIVO = "activo",
    INACTIVO = "inactivo",
    SOLICITADO = "solicitado",
    SUSPENDIDO ="suspendido",
    NO_REQUERIDO ="no_requerido"
}